import React from "react";
import { PageHeaderSection } from "../components";
import { Container } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import config from "../config/Main.json"

const Notice: React.FunctionComponent = () => {
  const { t } = useTranslation("notice");

  const subTitleStyle: React.CSSProperties = {
    fontSize: "2rem",
    fontWeight: 300,
    margin: "calc(2rem - .14286em) 0 1rem",
    color: "#000000de",
    fontFamily: "Avenir Next Codensed Ultralight",
  };

  const contentStyle: React.CSSProperties = {
    fontFamily: "Avenir Next Codensed Regular",
    fontSize: "1.2rem",
    fontWeight: 200,
    color: "#342714"
  };

  return (
    <Container>
      <PageHeaderSection
        id={"section_start"}
        headline="Informationen § 5 TMG"
        subheadline="About"
        content={<></>}
      />
      <div style={contentStyle}>
        <p>{config.company}</p>
        <p>{config.streetAddress}</p>
        <p>{config.postalCode} {config.locality}</p>
        <p><strong>{t("represented")}</strong></p>
        <p>{config.businessOrganisation}</p>
        <p>{t("business-manager")}: {config.businessManager}</p>
        <p>
          {config.localCourt}<br />
          {config.localCourtNumber}
        </p>

        <h2 style={subTitleStyle}>{t("contact-headline")}</h2>
        <p>{t("contact-phone")}: {config.phone}</p>
        <p>{t("contact-mail")}: {config.mail}</p>

        <h2 style={subTitleStyle}>{t("tax-headline")}</h2>
        <p>{t("tax-content")}</p>
        <p>{config.ustId}</p>

        <h2 style={subTitleStyle}>{t("dispute-headline")}</h2>
        <p>{t("dispute-content")}</p>

        <h2 style={subTitleStyle}>{t("contentLiability-headline")}</h2>
        <p>{t("contentLiability-content")}</p>

        <h2 style={subTitleStyle}>{t("linksLiability-headline")}</h2>
        <p>{t("linksLiability-content")}</p>

        <h2 style={subTitleStyle}>{t("copyright-headline")}</h2>
        <p>{t("copyright-content")}</p>
      </div>
    </Container>
  );
}

export default Notice;
